import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import BiologySection from './components/BiologySection';
import KittenDevelopment from './components/KittenDevelopment';
import EthicalCare from './components/EthicalCare';
import RespectGuide from './components/RespectGuide';
import InteractiveQuiz from './components/InteractiveQuiz';

function App() {
  const [activeTab, setActiveTab] = useState('biology');

  return (
    <div className="app-container">
      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
      <header className="hero-section">
        <div className="hero-badge">Felidae Evolutionary Biology & Behavior</div>
        <h1 className="hero-title">The Living World of Felines</h1>
        <p className="hero-subtitle">
          Explore morphological adaptations, kitten developmental physiology, veterinary ethology, 
          and the foundations of respect-based guardianship.
        </p>
      </header>

      <main className="content-container">
        {activeTab === 'biology' && <BiologySection />}
        {activeTab === 'kittens' && <KittenDevelopment />}
        {activeTab === 'care' && <EthicalCare />}
        {activeTab === 'respect' && <RespectGuide />}
        {activeTab === 'quiz' && <InteractiveQuiz />}
      </main>

      <footer className="app-footer">
        <p>Feline Biology, Care & Mutual Respect Portal &copy; {new Date().getFullYear()}</p>
        <p className="sub-note">Dedicated to science-informed feline welfare, compassionate ethology, and responsible companionship.</p>
      </footer>
    </div>
  );
}

export default App;